module.exports = __webpack_public_path__ + "media/images/city/028-chartres-cathedral-0904571d8761fa6b2abf28469c17955c.svg";